export default __webpack_public_path__ + "static/media/gam.4ae9686f.png";